import {
  AnomalyFileType,
  AnomalyHistoryQueryParams,
  GetAnomaliesQueryParams,
} from '@api/twin/AnomalyApi';
import { AttachmentApiGetAllParams } from '@api/twin/AttachmentApi';
import { AnomalyDocument } from './components/document/AnomalyDocumentCard';

export const anomalyQueryKeys = {
  default: ['anomaly_plugin'] as const,
  anomaly: (projectId: number, anomalyId: number) =>
    [...anomalyQueryKeys.default, projectId, anomalyId] as const,
  anomalies: (projectId: number, params: GetAnomaliesQueryParams) => [...anomalyQueryKeys.default, projectId, 'anomalies', params] as const,
  anomalies_default: (projectId: number) => [...anomalyQueryKeys.default, projectId, 'anomalies'] as const,
  documents: (anomalyId: number, params?: AttachmentApiGetAllParams) =>
    [...anomalyQueryKeys.default, anomalyId, 'documents', params] as const,
  documents_default: (anomalyId: number) =>
    [...anomalyQueryKeys.default, anomalyId, 'documents'] as const,
  visualize: (anomalyDocument: AnomalyDocument) =>
    [...anomalyQueryKeys.default, anomalyDocument] as const,
  commentDocuments: (commentId: number) =>
    [...anomalyQueryKeys.default, 'commentDocuments', commentId] as const,
  commentDocuments_default: () =>
    [...anomalyQueryKeys.default, 'commentDocuments'] as const,
  history_default: (anomalyId: number) =>
    [...anomalyQueryKeys.default, anomalyId, 'history'] as const,
  history: (anomalyId: number, params?: AnomalyHistoryQueryParams) => [
    ...anomalyQueryKeys.default,
    anomalyId,
    'history',
    params,
  ],
  export: (projectId: number, urlExportType: AnomalyFileType, anomalyIds: Array<number>) =>
    [
      ...anomalyQueryKeys.default,
      projectId,
      urlExportType,
      {
        anomalyIds,
      },
    ],
};
